import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, Router, RouterStateSnapshot } from '@angular/router';
import Keycloak from 'keycloak-js';
import { environment } from '../../../environments/environment';
import { getUserRoles } from '../auth/keycloak-roles.util';

export const authGuard: CanActivateChildFn = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const router = inject(Router);
  const keycloak = inject(Keycloak);

  if (environment.bypassAuth) {
    console.warn('Authentication bypassed - for development only!');
    return true;
  }

  await waitForKeycloakInitialization(keycloak);

  if (!keycloak.authenticated) {
    await keycloak.login({
      redirectUri: window.location.origin + state.url
    });
    return false;
  }

  const requiredRoles = route.data['roles'];
  if (!(requiredRoles instanceof Array) || requiredRoles.length === 0) {
    return true;
  }

  const userRoles = getUserRoles(keycloak);
  const hasRequiredRoles = requiredRoles.every((role: string) => userRoles.includes(role));

  if (!hasRequiredRoles) {
    await router.navigate(['/']);
    return false;
  }

  return true;
};

async function waitForKeycloakInitialization(keycloak: Keycloak): Promise<void> {
  const timeoutMs = 10_000;
  const pollMs = 50;
  const startedAt = Date.now();

  while (!keycloak.didInitialize && Date.now() - startedAt < timeoutMs) {
    await new Promise((resolve) => setTimeout(resolve, pollMs));
  }
}
